import { Injectable, Signal, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private alertConfig = signal<{
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    onComplete: () => void;
  } | null>(null);

  get alert(): Signal<{ title: string; message: string; onConfirm?: () => void } | null> {
    return this.alertConfig;
  }

  showAlert(title: string, message: string, onConfirm: () => void, onCancel: () => void = () => {}, onComplete: () => void = () => {}) {
    this.alertConfig.set({ title, message, onConfirm, onCancel, onComplete });
  }

  confirm() {
    this.alertConfig()?.onConfirm();
    this.alertConfig()?.onComplete();
    this.alertConfig.set(null);
  }

  close() {
    this.alertConfig()?.onCancel();
    this.alertConfig()?.onComplete();
    this.alertConfig.set(null);
  }
}
